import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { Button, Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';

import SelectUserCash from '../../select/selectUserCash';

import { numberFormat, StringToInt, _formatDate2 } from '../../../utils';
import { sumBy, reduce } from 'lodash';

import { makeGetToken, makeGetListAccount } from '../../../lib/selector';
import { translate } from 'react-i18next';
ReactModal.setAppElement('#root');

const customStyles = {
  content: {
    top: '80px',
    left: '50%',
    width: '675px',
    transform: 'translate(-50%)',
    bottom: 'auto',
  },
  overlay: {
    backgroundColor: 'transparent',
  },
};

class CashAdvance extends React.Component {
  state = {
    _totalFee: 0,
    _totalAdv: 0,
  };

  componentDidMount() {
    const { advMatch } = this.props;
    console.log(advMatch);
    if (advMatch) {
      const _totalAdv = advMatch && sumBy(advMatch, (o) => StringToInt(o.amt));

      const _totalFee =
        advMatch &&
        reduce(
          advMatch,
          function (sum, o) {
            return sum + o._calcInt;
          },
          0
        );

      this.setState({ _totalFee, _totalAdv });
    }
  }

  componentDidUpdate(preProps) {
    const { advMatch } = this.props;
    if (advMatch && advMatch !== preProps.advMatch) {
      console.log(advMatch);
      const _totalFee =
        advMatch &&
        reduce(
          advMatch,
          function (sum, o) {
            return sum + o._calcInt;
          },
          0
        );

      const _totalAdv = advMatch && sumBy(advMatch, (o) => StringToInt(o.amt));

      this.setState({ _totalFee, _totalAdv });
    }
  }

  render() {
    const {
      showModal,
      handleCloseModal,
      handleAcceptLoan,
      account,
      listAccount,
      advMatch,
      t,
    } = this.props;

    const { _totalFee, _totalAdv } = this.state;

    return (
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
      >
        <Card>
          <Card.Header className="bg-light text-center content-read fz-14 font-weight-bold">
            {t('txt-cash-advance')}
            <FaTimes
              className="float-right mt-1"
              onClick={() => handleCloseModal()}
            />
          </Card.Header>
          <Card.Body className="p-0 panel-cash-advance">
            <div className="p-3 d-flex justify-content-between align-items-center">
              <span>{t('txt-label-advance-request')}</span>
              <SelectUserCash
                defVal={account}
                grOptions={listAccount}
                isDisabled={true}
                // handleChangeUser={this._handleChangeUser}
                clsContainer="selCashOut"
              />
            </div>
            <div className="mr-3 ml-3">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{t('txt-label-sell-date')}</th>
                    <th className="text-center">
                      {t('txt-label-settlement-date')}
                    </th>
                    <th className="text-center">
                      {t('txt-label-trade-amount-af-fee')}
                    </th>
                    <th className="text-center">{t('txt-label-fee')}</th>
                    <th className="text-center">
                      {t('txt-label-cash-advance')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {advMatch &&
                    !!advMatch.length &&
                    advMatch.map((item) => (
                      <tr key={item.key}>
                        <td className="text-center">
                          {_formatDate2(item.ordrDt)}
                        </td>
                        <td className="text-center">
                          {_formatDate2(item.exprDt)}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.advanceAvail, 0, '0')}
                        </td>
                        <td className="text-right font-weight-bold">
                          {numberFormat(item._calcInt, 0, '0')}
                        </td>
                        <td className="text-right font-weight-bold">
                          {item.amt}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex align-items-center flex-row-reverse pb-3 pr-3 pl-3 pt-1">
              <div>
                <span className="content-read fz-14 mr-2">
                  {t('txt-label-total')}
                </span>
                <span className="i fz-14 font-weight-bold">
                  {numberFormat(_totalAdv, 0, '0')}
                </span>
              </div>
              <div className="mr-3">
                <span className="content-read fz-14 mr-2">{`${t(
                  'txt-label-total'
                )} ${t('txt-label-fee')}`}</span>
                <span className="fz-14 font-weight-bold">
                  {numberFormat(_totalFee, 0, '0')}
                </span>
              </div>
            </div>
          </Card.Body>
          <Card.Footer className="d-flex justify-content-between">
            <Button
              onClick={() => handleCloseModal()}
              className="font-weight-bold fz-14 btn-order"
              style={{ border: 'none' }}
            >
              {t('txt-cancel')}
            </Button>
            <Button
              onClick={() => handleAcceptLoan()}
              style={{ border: 'none' }}
              className="font-weight-bold fz-14 btn-order order-buy"
            >
              {t('txt-accept')}
            </Button>
          </Card.Footer>
        </Card>
      </ReactModal>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getListAccount = makeGetListAccount();

  const mapStateToProps = (state, props) => {
    return {
      token: getToken(state),
      listAccount: getListAccount(state),
    };
  };
  return mapStateToProps;
};

CashAdvance = connect(makeMapStateToProps)(CashAdvance);

export default translate('translations')(CashAdvance);
